<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="unit_no" [ttModel]="edit.unit_no" ttReadonly></tt-input>
        <tt-input ttLabel="unit_name" [(ttModel)]="edit.unit_name" ttRequired></tt-input>
        <tt-select ttLabel="propertyclass" [(ttModel)]="edit.propertyclass_id" [ttData]="selectListPropertyClasses" (ttModelChange)="onChanged($event, 'propertyclass_id')" ttDataId="propertyclass_id" ttDataName="propertyclass_name" [ttButtons]="propertyClassesButtons"></tt-select>
        <tt-input ttLabel="base_unit_name" [ttModel]="edit.base_unit_name" ttReadonly></tt-input>
        <tt-input ttLabel="tbf_unit_name" [(ttModel)]="edit.tbf_unit_name"></tt-input>
        <tt-input ttLabel="iso1000_unit_id" [(ttModel)]="edit.iso1000_unit_id"></tt-input>
        <tt-input-number ttLabel="quantity_pr_base_unit" [(ttModel)]="edit.quantity_pr_base_unit" ttTextAlign="right" ttFormatNumber ttDecimals="6"></tt-input-number>
        <tt-input ttLabel="quantity_formel" [(ttModel)]="edit.quantity_formel"></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>

        <div *ngIf="edit.unit_no !== '0'">
            <tt-button ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
            <tt-button-goto [ttText]="'translations'" [ttGoto]="'unitlang'" [ttGotoParms]="{ unit_no: edit.unit_no }"></tt-button-goto>
        </div>
    </tt-card>
</tt-page>
